import { useContext } from 'react';

import { Navigate } from '@sorare/routing';

import { ANY_SPORT_MY_CARDS_VAULT_TYPE } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { MyCardsLayoutContext } from 'layouts/my-cards/MyCardsLayout/MyCardsLayoutContext';

const MLBMyCardsVaultPage = () => {
  const { defaultRarity } = useContext(MyCardsLayoutContext);
  const { generateSportContextPath, sport } = useSportContext();
  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_MY_CARDS_VAULT_TYPE, {
        params: {
          type: defaultRarity,
        },
        sport,
      })}
    />
  );
};

export default MLBMyCardsVaultPage;
